import * as yup from "yup";

export const valueResoldCouponValidationSchema = yup.object({
  code: yup
    .string()
    .required("Field is required")
    .min(3, "Must be at least 3 characters long")
    .matches(
      /^[A-Z0-9]+$/,
      "Only uppercase latin letters and numbers are allowed"
    ),
  amountResold: yup
    .number()
    .typeError("Field is required")
    .required("Field is required")
    .positive("Only positive number are allowed"),
  discountType: yup.string().required("Field is required"),
  discountPercentage: yup.number().when("discountType", {
    is: "percentage",
    then: (schema) =>
      schema
        .typeError("Field is required")
        .required("Field is required")
        .positive("Only positive number are allowed")
        .max(95, "Discount should be not more than 95%"),
    otherwise: (schema) => schema.nullable()
  }),
  discountAmount: yup.number().when("discountType", {
    is: "amount",
    then: (schema) =>
      schema
        .typeError("Field is required")
        .required("Field is required")
        .positive("Only positive number are allowed"),
    otherwise: (schema) => schema.nullable()
  }),
  fromDate: yup.date().required("Field is required"),
  toDate: yup.date().required("Field is required"),
  fromTime: yup.string().required("Field is required"),
  toTime: yup.string().required("Field is required")
});
